var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icon-btn',_vm._g(_vm._b({},'icon-btn',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }